"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAndProceedToNextStep = exports.quoteValidator = void 0;
var _steps = require("../../constants/app/steps");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var isEmpty = function isEmpty(obj) {
  return obj === undefined || obj === null;
};
var isEmptyString = function isEmptyString(str) {
  return isEmpty(str) || str === '';
};
var isEmptyArray = function isEmptyArray(arr) {
  return isEmpty(arr) || arr.length === 0;
};
var isValidPostcode = function isValidPostcode(postcode) {
  return !isEmptyString(postcode) && postcode.length === 4;
};
var isValidEnumValue = function isValidEnumValue(enumValue) {
  return !isEmpty(enumValue) && enumValue >= 0;
};
var _validatePet = function validatePet(pet) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    validateQuotes: false,
    validateSelectedQuote: false
  };
  var isPetValid = !isEmpty(pet) && !isEmptyString(pet.breedCode) && !isEmptyString(pet.speciesCode) && !isEmptyString(pet.petDOB) && !isEmptyString(pet.petName) && isValidEnumValue(pet.desexed) && isValidEnumValue(pet.genderId) && !isEmptyString(pet.gender);
  if (config.validateQuotes) {
    isPetValid = isPetValid && !isEmptyArray(pet.petQuotes);
  }
  if (config.validateSelectedQuote) {
    isPetValid = isPetValid && !isEmpty(pet.selectedQuote) && !isEmpty(pet.selectedQuote.planNumber) && !isEmpty(pet.selectedQuote.basePremium) && pet.selectedQuote.planNumber > 0 && pet.selectedQuote.basePremium > 0;
  }
  return isPetValid;
};
var validateStepOne = function validateStepOne() {
  /* step one can always be visited */
  return true;
};
var validateStepTwo = function validateStepTwo(quote) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    validatePetQuotes: false
  };
  var validatePetQuotes = config.validatePetQuotes;
  if (isEmpty(quote) || isEmptyString(quote.appId)) {
    return false;
  }
  if (isEmptyArray(quote.pets) || isEmpty(quote.owner) || isEmptyString(quote.owner.dateofBirth) || !isValidPostcode(quote.owner.postcode)) {
    return false;
  }
  return quote.pets.every(function (pet) {
    return _validatePet(pet, {
      validateQuotes: validatePetQuotes
    });
  });
};
var validateStepThree = function validateStepThree(quote) {
  var isValidOnlineNumber = function isValidOnlineNumber(onlineNumber) {
    return !isEmpty(onlineNumber) && onlineNumber > 0;
  };
  var isValidOnlineQuoteNumber = function isValidOnlineQuoteNumber(onlineQuoteNumber) {
    return !isEmpty(onlineQuoteNumber) && onlineQuoteNumber > 0;
  };
  if (!validateStepTwo(quote) || !isValidOnlineNumber(quote.onlineNumber) || !isValidOnlineQuoteNumber(quote.onlineQuoteNumber) || isEmptyString(quote.quoteReferenceNumber) || isEmptyString(quote.paymentStartDate) || isEmptyString(quote.policyStartDate)) {
    return false;
  }
  return quote.pets.every(function (pet) {
    return _validatePet(pet, {
      validateQuotes: true,
      validateSelectedQuote: true
    });
  });
};
var validateStepFour = function validateStepFour(quote) {
  if (!validateStepThree(quote)) {
    return false;
  }
  var isValidEmail = function isValidEmail(email) {
    return !isEmptyString(email) && email.length <= 80 && email.length > 4;
  };
  var isValidTelephoneMobile = function isValidTelephoneMobile(tel) {
    return !isEmptyString(tel) && tel.length === 10;
  };
  return !isEmptyString(quote.owner.titleCode) && !isEmptyString(quote.owner.firstName) && !isEmptyString(quote.owner.surname) && !isEmptyString(quote.owner.address) && !isEmptyString(quote.owner.suburb) && !isEmptyString(quote.owner.state) && isValidTelephoneMobile(quote.owner.telephoneMobile) && isValidEmail(quote.owner.email);
};
var validateStepFive = function validateStepFive(quote) {
  return validateStepFour(quote);
};
var validateStepSix = function validateStepSix(quote) {
  return validateStepFive(quote) && !isEmpty(quote.westpac) && !isEmptyString(quote.westpac.reference);
};
var quoteValidator = exports.quoteValidator = {
  steps: function steps() {
    return {
      step1: function step1() {
        return {
          validate: function validate(quote) {
            return validateStepOne(quote);
          }
        };
      },
      step2: function step2() {
        return {
          validate: function validate(quote) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              validatePetQuotes: false
            };
            var validatePetQuotes = config.validatePetQuotes;
            return validateStepTwo(quote, {
              validatePetQuotes: validatePetQuotes
            });
          }
        };
      },
      step3: function step3() {
        return {
          validate: function validate(quote) {
            return validateStepThree(quote);
          }
        };
      },
      step4: function step4() {
        return {
          validate: function validate(quote) {
            return validateStepFour(quote);
          }
        };
      },
      step5: function step5() {
        return {
          validate: function validate(quote) {
            return validateStepFive(quote);
          }
        };
      },
      step6: function step6() {
        return {
          validate: function validate(quote) {
            return validateStepSix(quote);
          }
        };
      }
    };
  },
  validatePet: function validatePet(pet) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      validateQuotes: false,
      validateSelectedQuote: false
    };
    var validateQuotes = config.validateQuotes,
      validateSelectedQuote = config.validateSelectedQuote;
    return _validatePet(pet, {
      validateQuotes: validateQuotes,
      validateSelectedQuote: validateSelectedQuote
    });
  },
  isSubmitted: function isSubmitted(quote) {
    return !isEmpty(quote === null || quote === void 0 ? void 0 : quote.applicationSubmitted) && quote.applicationSubmitted === true;
  },
  isInitialOrEmpty: function isInitialOrEmpty(quote) {
    return isEmpty(quote === null || quote === void 0 ? void 0 : quote.appId);
  },
  arePetQuotesFilled: function arePetQuotesFilled(quote) {
    return !isEmpty(quote) && !isEmptyArray(quote.pets) && quote.pets.every(function (pet) {
      return !isEmptyArray(pet.petQuotes);
    });
  }
};

/**
 * Function that validates the quote response if it is valid to proceed to the next step of the quote journey
 * @param {*} step 
 * @param {*} quote 
 * @returns function | boolean
 */
var validateAndProceedToNextStep = exports.validateAndProceedToNextStep = function validateAndProceedToNextStep(step, quote) {
  var _validationMappping;
  var _quoteValidator$steps = quoteValidator.steps(),
    step3 = _quoteValidator$steps.step3,
    step4 = _quoteValidator$steps.step4,
    step5 = _quoteValidator$steps.step5;
  var validationMappping = (_validationMappping = {}, _defineProperty(_validationMappping, _steps.Steps.STEP_2, step3), _defineProperty(_validationMappping, _steps.Steps.STEP_3, step4), _defineProperty(_validationMappping, _steps.Steps.STEP_4, step5), _validationMappping);
  var validator = validationMappping[step.id];
  if (validator) return validator().validate(quote);
  return true;
};